module.exports = "    .card {\n    -webkit-box-shadow: 5px 5px 5px 0 rgba(0,0,0,0.1), 5px 5px 5px 0 rgba(0,0,0,0.1);\n            box-shadow: 5px 5px 5px 0 rgba(0,0,0,0.1), 5px 5px 5px 0 rgba(0,0,0,0.1);\n    }\n\n    .container {\n    padding: 10px;\n    }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/knee-on-belly-escaping/knee-on-belly-escaping.component.css
// module id = ./src/app/knee-on-belly-escaping/knee-on-belly-escaping.component.css
// module chunks = main